module.exports = __webpack_public_path__ + "img/recharge.bef14b75.png";